import { render } from "./Navbar.vue?vue&type=template&id=979c01b8&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=979c01b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-979c01b8"

export default script